"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridItemColumn = exports.gridItemRow = exports.gridItemArea = exports.gridItem = void 0;

var _stylitas = require("@creditas/stylitas");

const gridItemArea = ({
  area
}) => area && (0, _stylitas.css)`
    grid-area: ${area};
  `;

exports.gridItemArea = gridItemArea;

const gridItemRow = ({
  gridRow
}) => gridRow && (0, _stylitas.css)`
    ${(0, _stylitas.mq)({
  gridRow: (0, _stylitas.mediaValue)(gridRow.xs, gridRow.md)
})}
  `;

exports.gridItemRow = gridItemRow;

const gridItemColumn = ({
  gridColumn
}) => gridColumn && (0, _stylitas.css)`
    ${(0, _stylitas.mq)({
  gridColumn: (0, _stylitas.mediaValue)(gridColumn.xs, gridColumn.md)
})}
  `;

exports.gridItemColumn = gridItemColumn;

const gridItem = ({
  justifySelf,
  alignSelf,
  placeSelf
}) => (0, _stylitas.css)`
  justify-self: ${justifySelf};
  align-self: ${alignSelf};
  place-self: ${placeSelf};
`;

exports.gridItem = gridItem;